import React, { Component } from 'react';
import {
	DetailsList,
	DetailsListLayoutMode,
	Selection,
	SelectionMode,
	IColumn,
	IDetailsListStyles,
} from '@fluentui/react/lib/DetailsList';
import { IconButton } from '@fluentui/react/lib/Button';
import numbro from 'numbro';
const moment = require('moment');

const gridStyles: Partial<IDetailsListStyles> = {
	root: {
		overflowX: 'scroll',
		selectors: {
			'& [role=grid]': {
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'start',
				height: '52vh',
			},
		},
	},
	headerWrapper: {
		flex: '0 0 auto',
	},
	contentWrapper: {
		flex: '1 1 auto',
		overflowY: 'auto',
		overflowX: 'hidden',
	},
};

class MyContextMenu extends React.Component<any, any> {
	acttionbtnStyle = {
		verticalAlign: 'middle',
		maxHeight: '16px',
		maxWidth: '16px',
	};

	_menuItemClick = (_, item) => {
		console.log('--------------speaker fee menu click', item?.key);
		this.props.onMenuItemClick(item?.key);
	};

	_getMenuProps = () => {
		return {
			shouldFocusOnMount: true,
			shouldFocusOnContainer: true,
			items: [
				{
					key: 'details',
					text: 'Details',
					iconProps: { iconName: 'Search' },
					// hidden: !menuStatus.details,
					onClick: this._menuItemClick,
				},
				{
					key: 'edit',
					text: 'Edit',
					iconProps: { iconName: 'Edit' },
					// hidden: !menuStatus.edit,
					onClick: this._menuItemClick,
				},
				{
					key: 'delete',
					text: 'Delete',
					iconProps: { iconName: 'Delete' },
					// hidden: !menuStatus.delete,
					onClick: this._menuItemClick,
				},
			],
		};
	};

	render() {
		const menuProps = this._getMenuProps();
		return (
			<IconButton
				persistMenu={false}
				menuProps={menuProps}
				style={this.acttionbtnStyle}
			/>
		);
	}
}

export interface IDetailsListDocumentsExampleState {
	columns: IColumn[];
	selectionDetails: string;
	isModalSelection: boolean;
	isCompactMode: boolean;
	announcedMessage?: string;
}

export interface IDocument {
	key: string;
	itemNo: string;
	hccCode: string;
	eventDate: string;
	activityType: string;
	sapVendorCode: string;
	kolName: string;
	hospital: string;
	serviceHour: number;
	amount: number;
}

export default class SpeakerFeeSubList extends Component<
	any,
	IDetailsListDocumentsExampleState
> {
	private _selection: Selection;

	constructor(props: {}) {
		super(props);

		const columns: IColumn[] = [
			{
				key: 'optionMenu',
				name: 'Option',
				minWidth: 50,
				maxWidth: 50,
				// onRender: (item: IDocument) => <ContextualMenu />,
				onRender: (item: IDocument) => (
					<MyContextMenu item={item} onMenuItemClick={this._onMenuItemClick} />
				),
			},
			{
				key: 'itemNo',
				name: 'Item No.',
				fieldName: 'itemNo',
				minWidth: 80,
				maxWidth: 80,
				isRowHeader: true,
				isResizable: true,
				isSorted: true,
				isSortedDescending: false,
				sortAscendingAriaLabel: 'Sorted A to Z',
				sortDescendingAriaLabel: 'Sorted Z to A',
				onColumnClick: this._onColumnClick,
				data: 'string',
				isPadded: true,
			},
			{
				key: 'hccCode',
				name: 'HCC Code',
				fieldName: 'hccCode',
				minWidth: 80,
				maxWidth: 80,
				isRowHeader: true,
				isResizable: true,
				isSortedDescending: false,
				sortAscendingAriaLabel: 'Sorted A to Z',
				sortDescendingAriaLabel: 'Sorted Z to A',
				onColumnClick: this._onColumnClick,
				data: 'string',
				isPadded: true,
			},
			{
				key: 'eventDate',
				name: 'Event Date',
				fieldName: 'eventDate',
				minWidth: 50,
				maxWidth: 90,
				isResizable: true,
				onColumnClick: this._onColumnClick,
				data: 'string',
				isPadded: true,
			},
			{
				key: 'activityType',
				name: 'Activity Type',
				fieldName: 'activityType',
				minWidth: 50,
				maxWidth: 90,
				isResizable: true,
				isCollapsible: true,
				data: 'string',
				onColumnClick: this._onColumnClick,
				isPadded: true,
			},
			{
				key: 'sapVendorCode',
				name: 'Sap Vendor Code',
				fieldName: 'sapVendorCode',
				minWidth: 120,
				maxWidth: 120,
				isResizable: true,
				isCollapsible: true,
				data: 'string',
				onColumnClick: this._onColumnClick,
			},
			{
				key: 'kolName',
				name: 'KOL Name',
				fieldName: 'kolName',
				minWidth: 50,
				maxWidth: 90,
				isResizable: true,
				isCollapsible: true,
				data: 'string',
				onColumnClick: this._onColumnClick,
			},
			{
				key: 'hospitalName',
				name: 'Hospital',
				fieldName: 'hospitalName',
				minWidth: 150,
				maxWidth: 200,
				isResizable: true,
				isCollapsible: true,
				data: 'string',
				onColumnClick: this._onColumnClick,
			},
			{
				key: 'serviceHour',
				name: 'Service Hours',
				fieldName: 'serviceHour',
				minWidth: 50,
				maxWidth: 90,
				isResizable: true,
				isCollapsible: true,
				data: 'number',
				onColumnClick: this._onColumnClick,
			},
			{
				key: 'amount',
				name: 'Amount',
				fieldName: 'amount',
				minWidth: 120,
				maxWidth: 120,
				isResizable: true,
				isCollapsible: true,
				data: 'number',
				onColumnClick: this._onColumnClick,
				headerClassName: 'rightHead',
				className: 'rightCol',
			},
		];

		this._selection = new Selection({
			onSelectionChanged: () => {
				this.setState({
					selectionDetails: this._getSelectionDetails(),
				});
			},
		});

		this.state = {
			columns: columns,
			selectionDetails: this._getSelectionDetails(),
			isModalSelection: false,
			isCompactMode: false,
			announcedMessage: undefined,
		};
	}

	_renderItemColumn = (item: any, index: number, column: any) => {
		const fieldContent = item[column.fieldName];
		//return <span>1111</span>
		switch (column.key) {
			case 'eventDate':
				var eventDate = moment(fieldContent).format('YYYY-MM-DD');
				return <span>{eventDate}</span>;
			case 'amount':
				return (
					<span>
						{numbro(+fieldContent).format({
							thousandSeparated: true,
							mantissa: 2,
						})}
					</span>
				);

			default:
				return <span>{fieldContent}</span>;
		}
	};
	render() {
		const { columns, isCompactMode } = this.state;
		const { items } = this.props;

		return (
			<div
				style={{
					height: '500px',
					width: '100%',
					overflow: 'auto',
					padding: '10px',
				}}
			>
				<DetailsList
					items={items}
					compact={isCompactMode}
					columns={columns}
					selectionMode={SelectionMode.single}
					getKey={this._getKey}
					setKey='none'
					selection={this._selection}
					layoutMode={DetailsListLayoutMode.fixedColumns}
					isHeaderVisible={true}
					styles={gridStyles}
					// onItemInvoked={this._onItemInvoked}
					onRenderItemColumn={(item: any, index: any, column: any) =>
						this._renderItemColumn(item, index, column)
					}
				/>
			</div>
		);
	}

	componentDidUpdate(
		previousProps: any,
		previousState: IDetailsListDocumentsExampleState
	) {
		if (
			previousState.isModalSelection !== this.state.isModalSelection &&
			!this.state.isModalSelection
		) {
			this._selection.setAllSelected(false);
		}
	}

	private _getKey(item: any, index?: number): string {
		return item.key;
	}

	private _onChangeCompactMode = (
		ev: React.MouseEvent<HTMLElement>,
		checked?: boolean
	): void => {
		this.setState({ isCompactMode: checked || false });
	};

	private _onChangeModalSelection = (
		ev: React.MouseEvent<HTMLElement>,
		checked?: boolean
	): void => {
		this.setState({ isModalSelection: checked || false });
	};

	private _onItemInvoked(item: any): void {
		alert(`Item invoked: ${item.name}`);
	}

	private _getSelectionDetails(): any {
		const selectionCount = this._selection.getSelectedCount();

		switch (selectionCount) {
			case 0:
				return null;
			case 1:
				return this._selection.getSelection()[0];
			default:
				return null;
		}
	}

	private _onColumnClick = (
		ev: React.MouseEvent<HTMLElement>,
		column: IColumn
	): void => {
		const { columns } = this.state;
		const newColumns: IColumn[] = columns.slice();
		const currColumn: IColumn = newColumns.filter(
			(currCol) => column.key === currCol.key
		)[0];
		newColumns.forEach((newCol: IColumn) => {
			if (newCol === currColumn) {
				currColumn.isSortedDescending = !currColumn.isSortedDescending;
				currColumn.isSorted = true;
				this.setState({
					announcedMessage: `${currColumn.name} is sorted ${
						currColumn.isSortedDescending ? 'descending' : 'ascending'
					}`,
				});
			} else {
				newCol.isSorted = false;
				newCol.isSortedDescending = true;
			}
		});
		this.setState({
			columns: newColumns,
		});
	};

	itemOptionsClick = (data) => {
		return (e) => {
			console.log('----------------button', e, data);
		};
	};

	_onMenuItemClick = (menuKey) => {
		const selectItem = this._getSelectionDetails();
		this.setState({
			selectionDetails: selectItem,
		});
		this.props.onOptionMenuClick(menuKey, selectItem);
	};
}

function _copyAndSort<T>(
	items: T[],
	columnKey: string,
	isSortedDescending?: boolean
): T[] {
	const key = columnKey as keyof T;
	return items
		.slice(0)
		.sort((a: T, b: T) =>
			(isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1
		);
}
